import React, { useState } from 'react'
import { Button, Col, Divider, Row } from 'antd';
import XLSX from "xlsx";
import helper from '../../utils/helper';
import { getDataSheet, stepperMoving } from '../../stores/actions';
import { useDispatch } from 'react-redux';
import { InboxOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import fileSaver from 'file-saver';
import { TruckingModal } from '@operations/shared';
import moment from 'moment';
interface Props {
    validCols: any,
    fileUrl: string,
}

export default function UploadBulkCollections(props: Props) {
    const [validFiles, setValidFiles] = useState(false);
    const [viewInstructions, setViewInstructions] = useState(false);
    const [uploadingErrorMessage, setUploadingErrorMessage] = useState('');
    const [uploadingError, setUploadingError] = useState(false);
    const dispatch = useDispatch();

    const fileInputRef: React.RefObject<HTMLInputElement> = React.createRef();
    const saveFile = () => fileSaver.saveAs(props.fileUrl, `sample`);

    const forwardClickToInputElement = () => {
        fileInputRef.current!.click();
    };
    const handleFile = (file: any) => {
        setUploadingError(false)
        let file_size = file.size / (1024 * 1024), maxSize = 1, size;
        if (file.size < 1024) {
            size = file.size + ' B';
        } else if (file.size < (1024 * 1024)) {
            size = Math.floor(file.size / 1024) + ' KB';
        } else {
            size = Math.floor(file.size / (1024 * 1024)) + ' MB';
        }
        console.log(size);

        /* Boilerplate to set up FileReader */
        let acceptable_exe = helper.regexValidation.xlsxCsvRegex;
        if (!acceptable_exe.exec(file.name)) {
            setValidFiles(true);
        } else if (file_size > maxSize) {
            setValidFiles(true);
            // return Upload.LIST_IGNORE
        } else {
            setValidFiles(false);
            let fileReader = new FileReader(), rowObject: any, result, workbook: XLSX.WorkBook;
            console.log('rowObject - ', rowObject);

            fileReader.readAsBinaryString(file);
            fileReader.onload = (event: any) => {

                result = event.target.result;
                workbook = XLSX.read(result, { type: "binary", cellDates: true });
                workbook.SheetNames.forEach(sheet => {
                    rowObject = helper.sheetToJson(workbook.Sheets[sheet]);
                });

                const validation: any = helper.validateUploadSheetColumns(rowObject, props.validCols, true)
                console.log("🚀 ~ file: bulkUpdateUserStatus.tsx ~ line 135 ~ BulkUpdateUserStatus ~ handleFile ~ validation", validation)
                if (!validation.success) {
                    setUploadingError(true)
                    setUploadingErrorMessage(validation.message)

                    return
                }
                for (let row = 0; row < rowObject.length; row++) {
                    const element = rowObject[row];
                    if (typeof element.userID !== 'number') {
                        setUploadingErrorMessage('userID must be a number');
                        setUploadingError(true)
                        return 0
                    } else if (typeof element.amount !== 'number') {
                        setUploadingErrorMessage('amount must be a number');
                        setUploadingError(true)
                        return 0
                    }

                }

                const convertedData = Array.isArray(rowObject) && rowObject?.map((row: { collectionDate: string }) => ({
                    ...row,
                    collectionDate: moment(row.collectionDate, 'MM/DD/YYYY').format('YYYY-MM-DD')
                }));

                dispatch(getDataSheet({ sheetData: convertedData }))
                dispatch(stepperMoving(1));
            }
        }
    }

    const handleFileChange = (e: { target: { files: any, value: any }; }) => {
        const files = e.target.files;
        if (files && files[0]) handleFile(files[0]);
        e.target.value = null;
    }

    const cancelInstructionsModal = () => {
        setViewInstructions(false)
    }

    const instructions = <>
        <div className="validationProds">
            <h4 className='mt-4'>Mandatory fields</h4>
            <ul className='list-disc list-inside' about='Mandatory fields'>
                <li>userID</li>
                <li>amount</li>
                <li>collectionDate <span className='px-3 py-1 text-white bg-green-400 rounded-md'>Ex: 1988-01-01</span></li> 
            </ul>
            {<>
                <Divider />
                <h4>Optional fields </h4>
                <ul className='list-disc list-inside' about='Mandatory fields'>
                    <li>discount</li>
                </ul></>}
            <div className='flex justify-center'>
                <Button className='cancelInstruction' onClick={() => setViewInstructions(false)}>Cancel</Button>
            </div>
        </div>
    </>
    return (
        <>
            <div className="instructions">
                <Row>
                    <Col xl={18} md={18} sm={24} >
                        <p className="head">
                            Before uploading, download the following form to fill in the required data,<br /> then re-upload it to the system
                        </p>
                        <p className='flex items-center my-2 fillData' onClick={() => setViewInstructions(true)} ><ExclamationCircleOutlined /><span style={{ margin: '0 10px' }} className='fillHint'>
                            How to fill in the data sheet
                        </span></p>
                    </Col>
                    {<Col xl={6} md={6} sm={24}>
                        <Button className='sample' onClick={saveFile}>Download the file</Button>
                    </Col>}
                </Row>

            </div>

            {/* <Button className='uploadBtn' loading={spin} onClick={forwardClickToInputElement}>تحميل ملف بيانات الموظفين</Button><br /> */}
            <div className='upload' onClick={forwardClickToInputElement}>
                <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                </p>
                <p className="ant-upload-text">Click to upload the file</p>
                {/* <p className="ant-upload-hint">يدعم تحميل ملف واحد</p> */}
                {validFiles && <p className="error-hint">{'Allowed extension CSV or XLS up to 1 MB'}</p>}
            </div>
            <span className="maxSize">The recommended size is up to 1MB</span><br />
            {uploadingError && <span className="maxSize" style={{ color: 'red' }}>{uploadingErrorMessage}</span>}
            <form className="form-inline">
                <div className="form-group">
                    <label htmlFor="file">  </label>
                    <input
                        hidden
                        type="file"
                        className="form-control"
                        id="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        accept='.xlsx,.xls,.csv'
                    />
                </div>
            </form>


            <TruckingModal visibleModal={viewInstructions}
                content={instructions}
                handleCloseModal={cancelInstructionsModal} title={'How to fill the data sheet'} />
        </>
    )
}
